module.exports = __webpack_public_path__ + "static/media/galdinsLose_25000_50000.9569d6c5.png";